<template>
    <div class="mb-4 text-[14px] font-semibold">Categories</div>
    <form-radio
        :options="categories"
        v-model="postFilters.category"
        css-classes="w-5 h-5 mr-4 relative top-1"
    ></form-radio>
    <div class="mb-4 text-[14px] font-semibold">Types</div>
    <form-radio
        :options="types"
        v-model="postFilters.type"
        css-classes="w-5 h-5 mr-4 relative top-1"
    ></form-radio>
</template>
<script>
import FormRadio from "@/Components/FormRadio";

export default {
    name: "resource-post-filters",
    components: { FormRadio },
    props: {
        categories: {},
        postFilters: {},
        types: {},
    },
};
</script>
